module.exports = __webpack_public_path__ + "img/icon-quac-large.6f24e0eb.svg";